import {Component, OnInit, ViewChild} from "@angular/core";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {MatPaginator} from "@angular/material/paginator";
import {MatTableDataSource} from "@angular/material/table";

import {ActivatedRoute, Router} from "@angular/router";
import {Acesso} from "src/app/core/acesso";
import {CarregarPerfil} from "src/app/core/carregar-perfil";
import {ConfirmDialogComponent} from "../common/confirm-dialog/confirm-dialog.component";
import {AcaoExecutada} from "../../core/acao-executada";
import {AcaoExecutadaService} from "../../services/acao-executada/acao-executada.service";
import {Atividade} from "../../core/atividade";
import {Acoes} from "../../core/acoes";

@Component({
    selector: "app-acao-executada",
    templateUrl: "./acao-executada.component.html",
    styleUrls: ["./acao-executada.component.css"],
})
export class AcaoExecutadaComponent implements OnInit {
    @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

    descricaoFiltro: string;
    atividadeFiltro: Atividade;
    acaoFiltro: Acoes;

    acaoExecutada: AcaoExecutada = new AcaoExecutada();

    msg: string;
    mostrarTabela = false;

    displayedColumns: string[] = [
        "descricao",
        "atividade",
        "acao",
        "acoes",
    ];
    dataSource: MatTableDataSource<AcaoExecutada> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    constructor(
        private acaoExecutadaService: AcaoExecutadaService,
        private router: Router,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(
            this.activatedRoute.snapshot.data.perfilAcesso,
            this.perfilAcesso
        );

        this.dataSource.paginator = this.paginator;
        this.getAll();
    }

    limpar() {
        this.mostrarTabela = false;
        this.dataSource.data = [];
        this.descricaoFiltro = null;
        this.atividadeFiltro = null;
        this.acaoFiltro = null;
    }

    consultar() {
        if (this.descricaoFiltro || this.atividadeFiltro?.id || this.acaoFiltro?.id) {
            this.acaoExecutadaService
                .getFilter(this.descricaoFiltro, this.atividadeFiltro?.id, this.acaoFiltro?.id)
                .subscribe((listaAcoesExecutadas: AcaoExecutada[]) => {
                    if (!listaAcoesExecutadas) {
                        this.mostrarTabela = false;
                        this.msg = "Nenhum registro para a pesquisa selecionada";
                    } else {
                        this.dataSource.data = listaAcoesExecutadas ? listaAcoesExecutadas : [];
                        this.mostrarTabela = true;
                    }
                });
        } else {
            this.getAll();
        }
    }

    atualizar(acaoExec: AcaoExecutada) {
        this.router.navigate(["/acaoExecutada/cadastrar"], {
            queryParams: {id: acaoExec.id},
        });
    }

    deletar(acaoExec: AcaoExecutada) {
        this.chamaCaixaDialogo(acaoExec);
    }

    chamaCaixaDialogo(acaoExec: AcaoExecutada) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: `Certeza que deseja excluir a ação executada?`,
            textoConfirma: "SIM",
            textoCancela: "NÃO",
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((confirma) => {
            if (confirma) {
                this.acaoExecutadaService.excluir(acaoExec.id).subscribe(() => {
                    this.acaoExecutada.id = null;
                    this.consultar();
                });
            } else {
                dialogRef.close();
            }
        });
    }

    getAll() {
        this.acaoExecutadaService.getAll().subscribe((listaAcaoExecutada: AcaoExecutada[]) => {
            this.dataSource.data = listaAcaoExecutada ? listaAcaoExecutada : [];
            this.verificaMostrarTabela(listaAcaoExecutada);
        });
    }

    verificaMostrarTabela(listaAcaoExecutada: AcaoExecutada[]) {
        if (!listaAcaoExecutada || listaAcaoExecutada.length == 0) {
            this.mostrarTabela = false;
            this.msg = "Nenhum ação executada cadastrada.";
        } else {
            this.mostrarTabela = true;
        }
    }

    onValorChangeAtividade(event) {
        this.atividadeFiltro = event;
        this.acaoFiltro = null;
    }

    onValorChangeAcao(event) {
        this.acaoFiltro = event;
    }

}
